import ActionButton from "./ActionButton"
import Title from "../../Title"
import Img_x from "jsx:./../../../img/x.svg"
import Img_facebook from "jsx:./../../../img/facebook.svg"
import Img_instagram from "../../../img/Img_instagram"
import Img_tiktok from "../../../img/Img_tiktok"

const listProps = {
  margin: "auto",
  color: "#CEC8FE", // fallback color
  // background: "linear-gradient(180deg, #E2E6FD -17.86%, #CEC8FE 111.9%)",
  // backgroundClip: "text",
  // WebkitBackgroundClip: "text",
  // WebkitTextFillColor: "transparent",
  display: "flex",
  alignItems: "center",
  gap: 8,
}

const VideoShare = ({ shareVideo, isCaching }) => {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        gap: 12,
      }}
    >
      <Title title={"Your Video is Ready"} />

      <div
        css={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // flex: 1,
          gap: 24,
        }}
      >
        <div
          css={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 12,
          }}
        >
          <h3
            css={{
              margin: 0,
              textAlign: "center",
              fontFamily: "Montserrat, sans-serif",
              fontSize: 19,
              fontWeight: 500,
              color: "#CEC8FE", // fallback color
              // background:
              //   "linear-gradient(180deg, #E2E6FD -17.86%, #CEC8FE 111.9%)",
              // backgroundClip: "text",
              // WebkitBackgroundClip: "text",
              // WebkitTextFillColor: "transparent",
            }}
          >
            Share your <b>#HolidayHologram</b> and spread some festive cheer!
          </h3>

          <ul
            css={{
              listStyle: "none",
              margin: 0,
              textAlign: "left",
              fontFamily: "Montserrat, sans-serif",
              fontStyle: "normal",
              padding: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 12,
              alignSelf: "stretch",
            }}
          >
            <li css={{ ...listProps }}>
              <Img_instagram /> <Img_tiktok />
              @hypervsn_uk
            </li>
            <li css={{ ...listProps }}>
              <Img_x /> <Img_facebook /> @hypervsn
            </li>
          </ul>
        </div>
        <ActionButton
          label="Download Video"
          onClick={shareVideo}
          isCaching={isCaching}
        />
      </div>
    </div>
  )
}

export default VideoShare
